import { render, staticRenderFns } from "./OnBoardStart.vue?vue&type=template&id=184b6a66&scoped=true&"
import script from "./OnBoardStart.vue?vue&type=script&lang=js&"
export * from "./OnBoardStart.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardStart.vue?vue&type=style&index=0&id=184b6a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184b6a66",
  null
  
)

export default component.exports